import type { ReactNode } from 'react'

import { Alert } from 'src/Components/Alert'

export const NoResult = ({ children }: { children: ReactNode }) => (
  <Alert severity="info" margin={16}>
    {children}
  </Alert>
)
